module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ../~/rc-switch/es/index.js
// module id = 2703
// module chunks = 1